
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <div
    v-if="isLoading"
    class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
  >
    <b-spinner variant="primaire" :label="$t('chargement')"></b-spinner>
  </div>
  <!-- Fait la validation du formulaire si le idProfession a été mis à jour dans le store -->
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider rules="required" tag="div" class="d-none">
    <label for=""></label>
    <input v-model="idProfession" type="hidden" />
  </ValidationProvider>

  <Titre :content="contentTitre"></Titre>
  <Paragraphe :content="contentParagraphe"></Paragraphe>

  <!------- Situation professionnelle ------->
  <ListeChoix
    v-model="idChoixSituation"
    class="my-0 w-100"
    :content="contentSituationProfessionnelle"
  />
  <Hyperlien :content="contentAide" class="mt-n1 mb-2" />

  <!------- Profession ------->
  <div v-if="afficheProfession">
    <ListeChoix v-model="professionChoisie" class="mt-0 w-100" :content="contentProfession" />
  </div>

  <!------- Secteur d'activité ------->
  <div v-if="afficheSecteur">
    <ListeChoix v-model="secteurChoisi" class="mt-0 w-100" :content="contentSecteurActivite" />
  </div>
</div>
